import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-pencil-icon',
  templateUrl: './design-pencil.component.html'
})
export class DesignPencilComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
